import { inject } from "@angular/core";
import { Router, CanActivateFn, ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { AuthenticationService } from "../services/authentication.service";

export const AuthGuard: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  const router = inject(Router);
  const authenticationService = inject(AuthenticationService);
  
  try {
    const currentUser = authenticationService.currentUserValue;

    if (currentUser) {
      // authorised so return true
      return true;
    }

    // not logged in so redirect to login page with the return url
    router.navigate(["login"]);
    return false;
  } catch (error) {
    console.error(error);
    return false;
  }
};
